import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import { environment } from '../../../environments/environment';
import {AccountService} from "./account.service";

import {StockList} from "../models/stockList";

@Injectable({ providedIn: 'root' })
export class StockService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    getAll(offset: number, limit: number, productId: string) {
        return this.http.get<StockList>(`${environment.apiEndpoint}/v1/stocks?offset=` + offset + `&limit=` + limit + '&filters[product]=' + productId, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }
}
